import { OpportunityProgressFlags } from './../../utility/enums';
import { OpportSortBy, OpportunityStatus } from 'app/utility/enums';
import { Constants } from 'app/utility/constants';

export class OpportunitySearchParamsModel
{
    pageSize: number = 12;
    pageNumber: number = 1;
    orderBy: string = OpportSortBy.OpportNo.toString();
    orderByDesc: boolean = true;
    searchText: string = '';

    openStartDate: Date = new Date("1900-01-01T00:00:00Z");
    openEndDate: Date = new Date("2999-12-31T00:00:00Z");
    closedStartDate: Date = new Date("1900-01-01T00:00:00Z")
    closedEndDate: Date = new Date("2999-12-31T00:00:00Z");
    lastActivityStartDate: Date = new Date("1900-01-01T00:00:00Z");
    lastActivityEndDate: Date = new Date("2999-12-31T00:00:00Z");

    statusEnum: string = OpportunityStatus.All.toString();

    customerId: string = Constants.EmptyGuid;
    accountOwnerId: string = Constants.EmptyGuid;
    dealershipId: string = Constants.EmptyGuid;
    vehicleId: string = Constants.EmptyGuid;
    enforce: boolean;
    progressFlags: string = OpportunityProgressFlags.None.toString();
}
